import { useState } from "react";
import { Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

import ArrowIcon from "@/components/icons/ArrowIcon";
import CategoryCard from "../CategoryCard";
import { useTranslation } from "next-i18next";
import { v4 as uuidv4 } from "uuid";

const Categories = ({ data, homeData = null }) => {
  const categories = homeData ? homeData?.value : data;
  const {
    t,
    i18n: { language },
  } = useTranslation("home");

  const [swiper, set_swiper] = useState({});
  return categories?.length ? (
    <section className="w-11/12 mx-auto my-4 sm:my-10">
      <p className="mb-4 text-xl font-[500] text-center sm:text-3xl sm:mb-8">
        {homeData[`title-${language}`] || t("Shop By Category")}
      </p>
      <div className="relative">
        <Swiper
          onInit={(e) => set_swiper(e)}
          loop
          key={language}
          dir={language === "en" ? "ltr" : "rtl"}
          modules={[Autoplay]}
          pagination={{ clickable: true }}
          autoplay={{ delay: 3000, disableOnInteraction: false }}
          breakpoints={{
            320: {
              slidesPerView: 2.3,
              spaceBetween: 16,
            },
            421: {
              slidesPerView: 2.7,
              spaceBetween: 16,
            },
            571: {
              slidesPerView: 3.5,
              spaceBetween: 27,
            },
            769: {
              slidesPerView: 5,
              spaceBetween: 27,
            },
            991: {
              slidesPerView: 6,
              spaceBetween: 27,
            },
          }}
        >
          {categories?.map((category) => (
            <SwiperSlide key={uuidv4()}>
              <CategoryCard
                {...{
                  category,
                  locale: language,
                  imgPriority:
                    !!homeData && homeData?.position === "3" ? "high" : "low",
                }}
              />
            </SwiperSlide>
          ))}
        </Swiper>
        <button
          onClick={() => swiper?.slidePrev()}
          className="absolute z-20 items-center justify-center hidden -translate-y-1/2 rounded-full text-tertiary-600 top-1/2 -left-10 size-8 md:flex"
        >
          <ArrowIcon className="rotate-180 size-7" />
        </button>
        <button
          onClick={() => swiper?.slideNext()}
          className="absolute z-20 items-center justify-center hidden -translate-y-1/2 rounded-full text-tertiary-600 top-1/2 -right-10 size-8 md:flex"
        >
          <ArrowIcon className="size-7" />
        </button>
      </div>
    </section>
  ) : null;
};

export default Categories;
